export const ratingPt = {
  onIcon: { class: "text-yellow-100 text-base" },
  offIcon: { class: "text-gray-300 text-base" },
};
